import AccountService from "./account/accountService";
import ActivityLog from "./activityLog/activityLogService";
import AssetService from "./asset/assetService";
import BankService from "./bank/bankService";
import ContactService from "./contact/contactService";
import ExportService from "./export/exportService";
import MerchantService from "./merchant/merchantService";
import NotificationService from "./notification/notificationService";
import PackageService from "./package/packageService";
import PndService from "./pnd/pndService";
import PP30Service from "./pp30/pp30Service";
import ProductService from "./product/productService";
import TransactionService from "./transaction/transactionService";
import AuthenService from "./user/authenService";
import UserService from "./user/userService";
import WithholdingService from "./withholding/withholdingService";

export default {
  AuthenService,
  UserService,
  ContactService,
  MerchantService,
  WithholdingService,
  PP30Service,
  PndService,
  BankService,
  AccountService,
  ExportService,
  PackageService,
  ActivityLog,
  NotificationService,
  TransactionService,
  ProductService,
  AssetService,
};
